(function () {
    'use strict';

    function ReserveListV2ComponentController(__config, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, $translate) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.orderBagServiceItems = [];
        $ctrl.__config = __config;
        $ctrl.findStatusStyle = findStatusStyle;
        $ctrl.findStatusTitle = findStatusTitle;

        $ctrl.editReserve = editReserve;
        $ctrl.totalItems = 0
        $ctrl.page = 0
        $ctrl.pageSize = 10
        $ctrl.transition = transition

        loadAll();
        loadPage();

        function transition() {
            searchOrderBag()
        }

        function loadAll() {

            searchOrderBag();
        }

        function loadPage() {
            translatePartialLoader.addPart('orderBag');
            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader = translate.refresh();
        }


        function searchOrderBag() {

            makeSearchQuery();

            OrderBagServiceItemCustom.searchOrderBagItemsByQueryPagination().save($ctrl.searchQuery, function (data, headers) {
                $ctrl.totalItems = headers("X-Total-Count")
                $ctrl.orderBagServiceItems = data;
            });
        }


        function makeSearchQuery() {
            $ctrl.searchQuery = {};
            if ($ctrl.customerId)
                $ctrl.searchQuery.customerId = $ctrl.customerId;

            if ($ctrl.page > 0) $ctrl.searchQuery.pageNumber = $ctrl.page - 1;
            else $ctrl.searchQuery.pageNumber = $ctrl.page
            $ctrl.searchQuery.pageSize = $ctrl.pageSize;

            if (!$ctrl.fromDate)
                $ctrl.searchQuery.fromDate = new Date(2000, 1, 1);

            $ctrl.searchQuery.status = [1, 4, 5, 6];

        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function editReserve(orderBagServiceItem) {
            $state.go('supplierPanel-v2.editOrderBag', {id: orderBagServiceItem.orderBag.id})
        }
    }

    var ReserveListV2Component = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/reserve-list-v2/partial-form.reserve-list-v2.html',
        controller: ReserveListV2ComponentController,
        bindings:
            {
                customerId: '=',
                fromDate: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfReserveListV2', ReserveListV2Component)

    ReserveListV2ComponentController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', '$translate'];


})();

